import React, { useState, useEffect, useContext } from "react";
import { ModalPopProvider } from "./ModalPopContext";
import Technician from "./Technician";



const TechnicianMain = () => {

    const [staffId, setStaffId] = useState(null);

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const id = urlParams.get("id");
        setStaffId(id);
    }, [window.location.search]); // triggered on URL change

    return (
        <>
            <ModalPopProvider>
                <Technician staff_id={staffId} />
            </ModalPopProvider>


        </>
    )

}


export default TechnicianMain;